<div class="translations-editor">
  @if (activeTranslation$(); as translation) {
    <div #editorHeader class="translations-editor__sticky">
      <div class="translations-editor__header">
        <eiq-select
          [options]="languageOptions$()"
          [icon]="faGlobe"
          testId="translations-editor-language"
          [(ngModel)]="selectedLanguageCode$"
          (ngModelChange)="translationsService.setActiveLanguage($event)"
        />

        <div class="translations-editor__actions">
          <eiq-button
            [text]="'Import'"
            [icon]="faFileImport"
            [style]="'stroked'"
            [color]="'light'"
            testId="translations-editor-import"
            (clicked)="onImport()"
          ></eiq-button>
          <eiq-button
            [text]="'Export'"
            [icon]="faFileExport"
            [style]="'stroked'"
            [color]="'light'"
            testId="translations-editor-export"
            (clicked)="onExport()"
          ></eiq-button>
        </div>
      </div>

      <div class="translations-editor__status">
        <empathy-translations-status [translation]="translation"></empathy-translations-status>
      </div>

      <div class="translations-editor__filters">
        <eiq-search-input
          [(ngModel)]="search$"
          [placeholder]="'Search keys or text...'"
          [debounce]="100"
          testId="translations-editor-filter"
        ></eiq-search-input>

        <div class="translations-editor__checkboxes">
          <mat-checkbox color="accent" data-testid="translations-editor-missing-checkbox" [(ngModel)]="missing$">
            <span class="text__sm">Missing</span>
          </mat-checkbox>

          <mat-checkbox color="accent" data-testid="translations-editor-outdated-checkbox" [(ngModel)]="outdated$">
            <span class="text__sm">Outdated</span>
          </mat-checkbox>

          <mat-checkbox color="accent" data-testid="translations-editor-ignored-checkbox" [(ngModel)]="ignored$">
            <span class="text__sm">Ignored</span>
          </mat-checkbox>

          <mat-checkbox color="accent" data-testid="translations-editor-identical-checkbox" [(ngModel)]="identical$">
            <span class="text__sm">Identical</span>
          </mat-checkbox>
        </div>
      </div>
    </div>

    @for (group of filteredGroups$(); track group.groupKey) {
      <div #translationGroupAnchor class="translations-editor__group" [attr.data-translation-group-key]="group.groupKey">
        <div class="translations-editor__group-header">
          <div class="translations-editor__group-name">
            @if (group.isQuestionGroup) {
              <button
                type="button"
                class="translations-editor__group-select"
                [attr.data-testid]="'translations-group-' + group.groupKey + '-select-button'"
                (click)="translationsService.setActiveTranslationGroup(group.groupKey)"
              >
                <span class="fs__sm fw__600 question">{{ group.name }}</span>
                <fa-icon [icon]="faChevronRight"></fa-icon>
              </button>
            } @else {
              <span class="fs__sm fw__600">{{ group.name }}</span>
            }
          </div>

          <div class="translations-editor__group-actions">
            @if (group.groupKey === activeTranslationGroupKey$()) {
              <eiq-badge [icon]="faEye" [text]="'Current view'" [color]="'primary'"></eiq-badge>
            }

            @if (group.isQuestionGroup) {
              <eiq-button
                [title]="group.isIgnored ? 'Add question' : 'Ignore question'"
                [icon]="group.isIgnored ? faSquarePlus : faSquareMinus"
                [color]="'primary'"
                [style]="'icon'"
                [testId]="'translations-group-' + group.groupKey + '-ignore'"
                (clicked)="onQuestionIgnored(group.groupKey, !group.isIgnored)"
              ></eiq-button>
            }
          </div>
        </div>

        <div class="translations-editor__group-entries" [class.active]="group.groupKey === activeTranslationGroupKey$()">
          @for (row of group.rows; track row.key) {
            <empathy-translation-entry
              [row]="row"
              [showIgnoreButton]="!row.isQuestionTranslation || group.hasIgnoredEntries"
              [showIgnoreButtonOnHover]="row.isQuestionTranslation && !!row.translatedEntry?.ignoredInd"
              (entryChange)="onEntryChange(row.key, $event)"
              (ignoreEntry)="onEntryIgnored(row.key, $event)"
              (inputFocused)="translationsService.setActiveTranslationGroup(group.groupKey)"
            />
          }
        </div>
      </div>
    }
  } @else {
    <empathy-languages-empty
      [message]="'Add a target language to begin translating your survey content into other languages.'"
      [showLanguageSettingsButton]="true"
      [disableAddLanguage]="!canAddLanguage$()"
      (addLanguage)="addLanguage.emit()"
      (languageSettings)="translationsService.activeTabIndex$.set(translationTabs.LanguageSettings)"
    ></empathy-languages-empty>
  }
</div>
